"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var treeControl = {
  SUBTREE_STOP: 0
};
var _default = {
  treeControl: treeControl,
  walk: function walk(node, visitor) {
    var _this = this;

    if (node === null) return; // boolean options may have a null body

    if (!Array.isArray(node)) {
      var control = visitor(node);

      switch (control) {
        case treeControl.SUBTREE_STOP:
          return;
      }
    } else {
      node.forEach(function (n) {
        return _this.walk(n, visitor);
      });
    }

    var body = node.body;

    if (body) {
      body.forEach(function (child) {
        return _this.walk(child, visitor);
      });
    }
  }
};
exports.default = _default;